module.exports = __webpack_public_path__ + "img/[得意].07481b32.svg";